/**
 * long description for the file
 *
 * @summary short description for the file
 * @author Christian Juth
 */

export const logEvent = () => {
  // tslint:disable-next-line
  console.log('SETUP ANALYTICS FOR WEB');
};

export const initialize = async () => {
  // tslint:disable-next-line
  console.log('SETUP ANALYTICS FOR WEB');
};

export const logError = () => {
  // tslint:disable-next-line
  console.log('SETUP ANALYTICS FOR WEB');
};
